import { useState } from "react";
import { CobranzaJudicialColumsDTO, CobranzaJudicialDTO, Iprops } from "../models/cobranzaJudicial";
import { getCobranzaJudicial } from "../service/serviceCobranzaJudicial";
import { AxiosResponse } from "axios";
import { StatusCode } from "../../../../utils/enums";

type RespuestaApi<T> = {
    Resultados?: T[];
    resultados?: T[];
};

export function useCobranzaJudicial() {
    const [data, setData] = useState<CobranzaJudicialDTO[]>([]);

    const getCobranza = async (params: Iprops) => {
        const response: AxiosResponse<RespuestaApi<CobranzaJudicialDTO>> = await getCobranzaJudicial(params);

        if (response.status === StatusCode.Ok) {
            const items = response.data?.resultados ?? response.data?.Resultados ?? [];
            setData(Array.isArray(items) ? items : []);
        }
    };

    return {
        data,
        getCobranza,
    };
}